// AUTO GENERATED FILE - Changes WILL be lost.
// en-GB - used as 'en' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Betslip",
  "product.last60-row-single": "NBA Last 60 Single Match",
  "product.sb-english-single": "English Soccerbet Single Match",
  "product.sb-italian-single": "Italian Soccerbet Single Match",
  "product.sb-greek-single": "Greek Soccerbet Single Match",
  "product.sb-english-league": "English Soccerbet League",
  "product.sb-italian-league": "Italian Soccerbet League",
  "product.sb-greek-league": "Greek Soccerbet League",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Place bet",
  "betslip.clear": "Clear all",
  "betslip.clearResult": "Clear",
  "betslip.noSelections": "Add selections to start betting",
  "betslip.notLoggedIn": "Login to start betting",
  "betslip.refresh": "Refresh",
  "betslip.totalStake": "Total stake",
  "betslip.noHistoryData": "No bet information available",
  "betslip.openBets": "Open Bets",
  "betslip.betHistory": "Bet History",
  "betslip.betHistoryWon": "Won",
  "betslip.betHistoryLost": "Lost",
  "loading.loading": "Loading",
  "loading.account": "Loading account",
  "loading.league": "Loading league",
  "loading.gameweeks": "Loading game weeks",
  "loading.markets": "Loading markets",
  "loading.bethistory": "Loading bet history",
  "login.loginRequired": "Login Required",
  "login.loginToBet": "Please login to start betting",
  "navigation.back": "Back",
  "navigation.close": "Close",
  "video.liveStreamAvailable": "Live streaming available",
  "video.logInToWatch": "Please log in to watch",
  "error.error": "Error",
  "error.404": "Page not found",
  "error.gameLaunchFailed": "Unable to launch game",
  "error.unknownErrorCode": "Unknown error: {code}",
  "error.minUnitStakeLimitExceeded": "Minimum stake is {limit}",
  "error.maxUnitStakeLimitExceeded": "Maximum stake is {limit}",
  "error.minTotalStakeLimitExceeded": "Minimum total stake is {limit}",
  "error.maxTotalStakeLimitExceeded": "Maximum total stake is {limit}",
  "error.stakeInvalidMultiple": "Stake must be a multiple of {multiple}",
  "error.notPlaced": "Not Placed",
  "error.wagerDisallowed": "Wager disallowed",
  "error.errorEventIsOff": "Event has started",
  "multiplebet.Singles": "Singles",
  "multiplebet.Doubles": "Doubles",
  "multiplebet.Trebles": "Trebles",
  "multiplebet.Accumulator": "Accumulator",
  "multiplebet.Perm 4-Folds": "Perm 4-Folds",
  "multiplebet.Perm 5-Folds": "Perm 5-Folds",
  "multiplebet.Perm 6-Folds": "Perm 6-Folds",
  "multiplebet.Perm 7-Folds": "Perm 7-Folds",
  "multiplebet.Perm 8-Folds": "Perm 8-Folds",
  "multiplebet.Perm 9-Folds": "Perm 9-Folds",
  "error.excess_bets": "Maximum of {limit} simultaneous wagers on betslip; please remove a wager",
  "product.sb-turkish-league": "Turkish Soccerbet League",
  "error.minBetslipLimitExceeded": "Minimum total betslip stake is {limit}",
  "error.maxBetslipLimitExceeded": "Maximum total betslip stake is {limit}",
  "error.exceededMaxPayout": "Maximum potential payout is {limit}; please reduce your stake.",
  "betslip.potentialReturns": "Potential Returns",
  "betslip.taxDisclaimer": "All your net winnings are taxed upon bet settlement. The tax amount will be calculated depending on the potential winnings of the bet.",
  "error.maintenanceEnabled": "The server is currently undergoing maintenance",
  "error.internalError": "Internal Error",
  "error.invalidSession": "The session is invalid",
  "error.accountDisabled": "Account is disabled",
  "error.invalidPlayerID": "Invalid player ID",
  "error.insufficientBalance": "Insufficient balance",
  "error.configError": "Configuration error",
  "error.betPlaceFailed": "Failed to place bet",
  "error.invalidProductID": "Invalid product ID",
  "error.playerReachedGamingLimits": "Player reached responsible gaming limits",
  "error.gameCycleDoesNotExist": "The game cycle does not exist",
  "error.betAmountLimitExceeded": "Exceeded potential win limit for unverified players",
  "betslip.netStake": "Net Stake",
  "betslip.tax": "Tax",
  "error.badReturns": "Potential returns are lower than gross stake",
  "betslip.taxDisclaimerPoland": "Winnings will be reduced by 10% for amounts over PLN 2,280.",
  "error.incompatibleVersion": "Unsupported application version. Please upgrade.",
  "product.iihf-row-single": "IIHF World Championship",
  "iihf.fixture": "{home} VS. {away}",
  "iihf.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "No more bets",
  "playtime": "Play Time",
  "gameId": "Game ID",
  "noGames": "There are no games available. Check back soon.",
  "Home": "Home",
  "Away": "Away",
  "Visitor": "Visitor",
  "rules": "Rules",
  "soccerbet.gameWeek": "GAMEWEEK",
  "soccerbet.noGameWeeks": "There are no game weeks available. Check back soon.",
  "soccerbet.league": "League Standings",
  "soccerbet.table.name": "Name",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "market.abbr.Both Teams To Score": "BTTS",
  "market.Both Teams To Score": "Both Teams To Score",
  "market.Over / Under": "Over/Under",
  "market.Double Chance": "Double Chance",
  "market.Match Result": "Match Result",
  "market.Exact Goals": "Exact Goals",
  "market.Correct Score": "Correct Score",
  "market.Match Result Both Score": "Match Result and Both Teams to Score",
  "market.Result Und/Over 1.5 Total Goals": "Match Result and Over/Under 1.5 Total Goals",
  "market.Result Und/Over 2.5 Total Goals": "Match Result and Over/Under 2.5 Total Goals",
  "market.Under Over 1.5 Total Goals": "Over/Under 1.5 Total Goals",
  "market.Under Over 2.5 Total Goals": "Over/Under 2.5 Total Goals",
  "market.Under Over 3.5 Total Goals": "Over/Under 3.5 Total Goals",
  "market.Under Over 4.5 Total Goals": "Over/Under 4.5 Total Goals",
  "market.Total Goals 1 To 2": "Total Goals 1 To 2",
  "market.Total Goals 1 To 3": "Total Goals 1 To 3",
  "market.Total Goals 1 To 4": "Total Goals 1 To 4",
  "market.Total Goals 2 To 3": "Total Goals 2 To 3",
  "market.Total Goals 2 To 4": "Total Goals 2 To 4",
  "market.Under Over 1.5 Home Goals": "Over/Under 1.5 Home Team Goals",
  "market.Under Over 1.5 Away Goals": "Over/Under 1.5 Away Team Goals",
  "market.Home Team Exact Goals": "Home Team Exact Goals",
  "market.Away Team Exact Goals": "Away Team Exact Goals",
  "selection.Yes": "Yes",
  "selection.No": "No",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Yes",
  "selection.1+No": "1+No",
  "selection.X+Yes": "X+Yes",
  "selection.X+No": "X+No",
  "selection.2+Yes": "2+Yes",
  "selection.2+No": "2+No",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "OVER",
  "selection.Under": "UNDER",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "sb-turkish.team.abbr.AKB": "AKB",
  "sb-turkish.team.abbr.BES": "BES",
  "sb-turkish.team.abbr.FEN": "FEN",
  "sb-turkish.team.abbr.GAL": "GAL",
  "sb-turkish.team.abbr.TRA": "TRA",
  "sb-turkish.team.abbr.ANT": "ANT",
  "sb-turkish.team.abbr.GEN": "GEN",
  "sb-turkish.team.abbr.KAS": "KAS",
  "sb-turkish.team.abbr.BUR": "BUR",
  "sb-turkish.team.abbr.KAY": "KAY",
  "sb-turkish.team.abbr.SIV": "SIV",
  "sb-turkish.team.abbr.IBA": "IBA",
  "sb-turkish.team.abbr.HAT": "HAT",
  "sb-turkish.team.abbr.ADS": "ADS",
  "sb-turkish.team.abbr.ALT": "ALT",
  "sb-turkish.team.abbr.GAZ": "GAZ",
  "sb-turkish.team.abbr.GOZ": "GOZ",
  "sb-turkish.team.abbr.KON": "KON",
  "sb-turkish.team.abbr.CRS": "CRS",
  "sb-turkish.team.abbr.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "sb-english.team.abbr.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham Forest",
  "sb-english.team.abbr.NOT": "NOT",
  "market.Overall Winner": "Overall Winner",
  "market.Last60 Winner": "Last 60 Winner",
  "market.Both Teams Over 2.5 Last60": "Both Teams Over 2.5 Last 60",
  "market.Both Teams Over 3.5 Last60": "Both Teams Over 3.5 Last 60",
  "market.First Team To Score In Last60": "First Team To Score In Last 60",
  "market.Last60 Winner And Winning Margin": "Last 60 Winner And Winning Margin",
  "market.First To Score 4 Points Last60": "First To Score 4 Points Last 60",
  "market.Home Under/Over 4.5 Last60": "{home} Over/Under 4.5 Last 60",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} Over/Under 4.5 Last 60",
  "market.Home Under/Over 5.5 Last60": "{home} Over/Under 5.5 Last 60",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} Over/Under 5.5 Last 60",
  "market.Last60 Winner And O/U 11.5": "Last 60 Winner And O/U 11.5",
  "market.Last60 Points Difference": "Last 60 Winning Margin",
  "market.Total 3-Pointers Last60": "Total 3-Pointers Last 60",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} & 10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} & Over",
  "selection.Home & Under": "{home} & Under",
  "selection.Visitor & Over": "{visitor} & Over",
  "selection.Visitor & Under": "{visitor} & Under",
  "last60.team.ATL": "Atlanta Hawks",
  "last60.team.BKN": "Brooklyn Nets",
  "last60.team.BOS": "Boston Celtics",
  "last60.team.CHA": "Charlotte Hornets",
  "last60.team.CHI": "Chicago Bulls",
  "last60.team.CLE": "Cleveland Cavaliers",
  "last60.team.DAL": "Dallas Mavericks",
  "last60.team.DEN": "Denver Nuggets",
  "last60.team.DET": "Detroit Pistons",
  "last60.team.GSW": "Golden State Warriors",
  "last60.team.HOU": "Houston Rockets",
  "last60.team.IND": "Indiana Pacers",
  "last60.team.LAC": "LA Clippers",
  "last60.team.LAL": "Los Angeles Lakers",
  "last60.team.MEM": "Memphis Grizzlies",
  "last60.team.MIA": "Miami Heat",
  "last60.team.MIL": "Milwaukee Bucks",
  "last60.team.MIN": "Minnesota Timberwolves",
  "last60.team.NOP": "New Orleans Pelicans",
  "last60.team.NYK": "New York Knicks",
  "last60.team.OKC": "Oklahoma City Thunder",
  "last60.team.ORL": "Orlando Magic",
  "last60.team.PHI": "Philadelphia 76ers",
  "last60.team.PHX": "Phoenix Suns",
  "last60.team.POR": "Portland Trail Blazers",
  "last60.team.SAC": "Sacramento Kings",
  "last60.team.SAS": "San Antonio Spurs",
  "last60.team.TOR": "Toronto Raptors",
  "last60.team.UTA": "Utah Jazz",
  "last60.team.WAS": "Washington Wizards",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "ORL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}",
  "market.Total 3-Pointers Last60 1-6": "Total 3-Pointers Last 60",
  "market.Last60 Winning Margin 1": "Last 60 Winning Margin",
  "market.Last60 Winning Margin 2": "Last 60 Winning Margin",
  "market.Last60 Winning Margin 3": "Last 60 Winning Margin",
  "market.Last60 Winner & Winning Margin 1": "Last 60 Winner & Winning Margin",
  "market.Last60 Winner & Winning Margin 2": "Last 60 Winner & Winning Margin",
  "market.Last60 Winner & Winning Margin 3": "Last 60 Winner & Winning Margin",
  "market.Total 3-Pointers Last60 1-3+": "Total 3-Pointers Last 60",
  "selection.Home & 1": "{home} & 1",
  "selection.Home & 2": "{home} & 2",
  "selection.Home & 3": "{home} & 3",
  "selection.Home & 4": "{home} & 4",
  "selection.Home & 5": "{home} & 5",
  "selection.Home & 6": "{home} & 6",
  "selection.Home & 7": "{home} & 7",
  "selection.Home & 8": "{home} & 8",
  "selection.Home & 9": "{home} & 9",
  "selection.Home & 10": "{home} & 10",
  "selection.Home & 11": "{home} & 11",
  "selection.Home & 12": "{home} & 12",
  "selection.Home & 13": "{home} & 13",
  "selection.Home & 14": "{home} & 14",
  "selection.Home & 15": "{home} & 15",
  "selection.Home & 16": "{home} & 16",
  "selection.Home & 17+": "{home} & 17+",
  "selection.Visitor & 1": "{visitor} & 1",
  "selection.Visitor & 2": "{visitor} & 2",
  "selection.Visitor & 3": "{visitor} & 3",
  "selection.Visitor & 4": "{visitor} & 4",
  "selection.Visitor & 5": "{visitor} & 5",
  "selection.Visitor & 6": "{visitor} & 6",
  "selection.Visitor & 7": "{visitor} & 7",
  "selection.Visitor & 8": "{visitor} & 8",
  "selection.Visitor & 9": "{visitor} & 9",
  "selection.Visitor & 10": "{visitor} & 10",
  "selection.Visitor & 11": "{visitor} & 11",
  "selection.Visitor & 12": "{visitor} & 12",
  "selection.Visitor & 13": "{visitor} & 13",
  "selection.Visitor & 14": "{visitor} & 14",
  "selection.Visitor & 15": "{visitor} & 15",
  "selection.Visitor & 16": "{visitor} & 16",
  "selection.Visitor & 17+": "{visitor} & 17+",
  "selection.Home & 1-2": "{home} & 1-2",
  "selection.Home & 3-4": "{home} & 3-4",
  "selection.Home & 5-6": "{home} & 5-6",
  "selection.Home & 7-8": "{home} & 7-8",
  "selection.Home & 9-10": "{home} & 9-10",
  "selection.Home & 11-12": "{home} & 11-12",
  "selection.Home & 13-14": "{home} & 13-14",
  "selection.Home & 15-16": "{home} & 15-16",
  "selection.Visitor & 1-2": "{visitor} & 1-2",
  "selection.Visitor & 3-4": "{visitor} & 3-4",
  "selection.Visitor & 5-6": "{visitor} & 5-6",
  "selection.Visitor & 7-8": "{visitor} & 7-8",
  "selection.Visitor & 9-10": "{visitor} & 9-10",
  "selection.Visitor & 11-12": "{visitor} & 11-12",
  "selection.Visitor & 13-14": "{visitor} & 13-14",
  "selection.Visitor & 15-16": "{visitor} & 15-16",
  "iihf-row.team.CAN": "Canada",
  "iihf-row.team.FIN": "Finland",
  "iihf-row.team.RUS": "Russia",
  "iihf-row.team.USA": "United States",
  "iihf-row.team.CZE": "Czechia",
  "iihf-row.team.SWE": "Sweden",
  "iihf-row.team.SVK": "Slovakia",
  "iihf-row.team.NOR": "Norway",
  "iihf-row.team.DEN": "Denmark",
  "iihf-row.team.abbr.CAN": "CAN",
  "iihf-row.team.abbr.FIN": "FIN",
  "iihf-row.team.abbr.RUS": "RUS",
  "iihf-row.team.abbr.USA": "USA",
  "iihf-row.team.abbr.CZE": "CZE",
  "iihf-row.team.abbr.SWE": "SWE",
  "iihf-row.team.abbr.SVK": "SVK",
  "iihf-row.team.abbr.NOR": "NOR",
  "iihf-row.team.abbr.DEN": "DEN",
  "market.Icematchresnt": "Match Result (1X2) (Regulation Time)",
  "market.Icematchresot": "Match Result (1,2) (Including Overtime)",
  "market.Icebothteamstoscore": "Both Teams to Score (Regulation Time)",
  "market.Icecorrectscoreot": "Correct Score (Including Overtime)",
  "market.Iceexactgoalsot": "Exact Goals (Including Overtime)",
  "market.Icegamelines2nt": "Game Lines 2-way (Regulation Time)",
  "market.Icegamelines3nt": "Game Lines 3-way (Regulation Time)",
  "market.Iceou2p5totalgoalsot": "Over 2.5 Total Goals (Including Overtime)",
  "market.Iceou3p5totalgoalsot": "Over 3.5 Total Goals (Including Overtime)",
  "market.Iceou4p5totalgoalsot": "Over 4.5 Total Goals (Including Overtime)",
  "market.Iceteamaexactgoalsot": "Home Team Exact Goals (Including Overtime)",
  "market.Iceteambexactgoalsot": "Away Team Exact Goals (Including Overtime)",
  "market.Icematchresou3p5totalgoalsnt": "Match Result and Over/Under 3.5 Goals (Regulation Time)",
  "market.Icematchresou3p5totalgoalsot": "Match Result and Over/Under 3.5 Goals (Including Overtime)",
  "market.Icehighestscoreperiodnt": "Highest Scoring Period Lines (Regulation Time)",
  "market.Iceou25goalsteamateambot": "Over/Under 2.5 Home or Away Team Goals (Including Overtime)",
  "market.Icefirstteamtoscore": "Which Team will score first? (Including Overtime)",
  "market.Iceteamtowinmostperiods": "Team to Win Most Periods (Regulation Time)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3.5",
  "selection.A -3.0": "{home} -3.0",
  "selection.A -2.5": "{home} -2.5",
  "selection.A -2.0": "{home} -2.0",
  "selection.A -1.5": "{home} -1.5",
  "selection.A -1.0": "{home} -1.0",
  "selection.A +1.0": "{home} +1.0",
  "selection.A +1.5": "{home} +1.5",
  "selection.A +2.0": "{home} +2.0",
  "selection.A +2.5": "{home} +2.5",
  "selection.A +3.0": "{home} +3.0",
  "selection.A +3.5": "{home} +3.5",
  "selection.B -3.5": "{away} -3.5",
  "selection.B -3.0": "{away} -3.0",
  "selection.B -2.5": "{away} -2.5",
  "selection.B -2.0": "{away} -2.0",
  "selection.B -1.5": "{away} -1.5",
  "selection.B -1.0": "{away} -1.0",
  "selection.B +1.0": "{away} +1.0",
  "selection.B +1.5": "{away} +1.5",
  "selection.B +2.0": "{away} +2.0",
  "selection.B +2.5": "{away} +2.5",
  "selection.B +3.0": "{away} +3.0",
  "selection.B +3.5": "{away} +3.5",
  "selection.X -3.0": "X -3.0",
  "selection.X -2.0": "X -2.0",
  "selection.X -1.0": "X -1.0",
  "selection.X +1.0": "X +1.0",
  "selection.X +2.0": "X +2.0",
  "selection.X +3.0": "X +3.0",
  "selection.A & Over": "{home} & Over",
  "selection.A & Under": "{home} & Under",
  "selection.X & Over": "X & Over",
  "selection.X & Under": "X & Under",
  "selection.B & Over": "{away} & Over",
  "selection.B & Under": "{away} & Under",
  "selection.A Over": "{home} Over",
  "selection.A Under": "{home} Under",
  "selection.B Over": "{away} Over",
  "selection.B Under": "{away} Under"
}
